import nBossConnection from 'modules/base/service/nBossConnection';
import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import TransformerEditDto from '../dto/TransformerEditDto';
import WorkflowConverter from '../component/WorkflowConverter';

class TransformerEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'transformerEditControl';
	}

	/**
	 * @return {Promise<TransformerEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new TransformerEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<TransformerEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new TransformerEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {TransformerEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		dto.export = dto.json ? WorkflowConverter(dto.name, dto.json) : null;
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {TransformerEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		dto.export = dto.json ? WorkflowConverter(dto.name, dto.json) : null;
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new TransformerEditService();
